import * as React from 'react';

function SvgPersonCircle(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zM9.586 7.616c.609-.645 1.466-1 2.414-1 .948 0 1.798.357 2.41 1.006.619.658.92 1.541.85 2.492-.143 1.886-1.605 3.425-3.26 3.425-1.655 0-3.12-1.539-3.26-3.426-.07-.958.231-1.844.846-2.497zM12 20.462a8.436 8.436 0 01-6.058-2.56 5.909 5.909 0 011.69-1.607c1.225-.785 2.776-1.218 4.368-1.218 1.592 0 3.143.433 4.367 1.218.665.418 1.24.965 1.69 1.608A8.435 8.435 0 0112 20.462z" })));
}

export default SvgPersonCircle;
